import { createSelector } from "reselect";

import Store from "../../../../../redux/store";
import { IError } from "../../../../../redux/actions/errorHandlingAction";
import { WorkOrdersState } from "../../../../../redux/reducers/workOrdersReducer";
import { BriefProductForm } from "../../../../../features/products/types/brief-product-form/brief-product-form.interface";
import { Nullable } from "../../../../../types/common";

import { getWorkOrderState } from "../../../store/work-order.store";

import { WorkOrderProductsState } from "../types/work-order-products.interface";

import * as actions from "./work-order-products.actions";

export const getWorkOrderProductsState = createSelector(
  getWorkOrderState,
  (state: WorkOrdersState) => state.productsState
);

export const isLoading = createSelector(
  getWorkOrderProductsState,
  (state: WorkOrderProductsState) => state.loading
);

export const getErrors = createSelector(
  getWorkOrderProductsState,
  (state: WorkOrderProductsState) => state.errors
);

export const getProducts = createSelector(
  getWorkOrderProductsState,
  (state: WorkOrderProductsState) => state.products
);

export const hasErrors = createSelector(getErrors, (errors: Nullable<IError>) => !!errors);

export function fetchProducts(workOrderId: number) {
  Store.dispatch(actions.fetchProducts(workOrderId));
}

export function updateProducts(form: BriefProductForm[], workOrderId: number) {
  Store.dispatch(actions.updateProducts(form, workOrderId));
}

export function addProduct(product: number, workOrderId: number) {
  Store.dispatch(actions.addProduct(product, workOrderId));
}
